import ScreenTitleComponent from './ScreenTitleComponent';
export * from './ScreenTitleComponent';
export default ScreenTitleComponent;
